var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStickers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#87BB4F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5141 23.1362C34.2908 23.1362 36.0175 23.6492 37.5064 24.5876C37.4939 24.012 37.4313 23.4114 37.3312 22.8109C36.4554 17.6684 32.2889 13.5269 27.1339 12.6761C18.5632 11.2622 11.2561 18.5693 12.67 27.14C13.5208 32.295 17.6623 36.4615 22.8048 37.3373C23.4053 37.4249 23.9934 37.4875 24.569 37.5C23.6306 36.0111 23.1301 34.2969 23.1301 32.5202C23.1301 27.3402 27.3341 23.1362 32.5141 23.1362ZM25.0067 32.5202C25.0067 34.3595 25.6699 36.0486 26.7709 37.3499L37.3436 26.7772C36.0423 25.6761 34.3532 25.013 32.5139 25.013C28.3725 25.013 25.0067 28.3787 25.0067 32.5202Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStickers);
export default __webpack_public_path__ + "static/media/icon_stickers.314237ac01f2632434f1486d046eeb43.svg";
export { ForwardRef as ReactComponent };